export default __webpack_public_path__ + "static/media/Group 1285TataNeu@2x.16093c1d.png";